import { getLogger } from '../diagnostics/logger';
import moment from 'moment';
import {
  LOAD_COMMAND_TYPES_FAILURE,
  LOAD_COMMAND_TYPES_PENDING,
  LOAD_COMMAND_TYPES_SUCCESS,
} from '../actions/actionTypes';
import { Action } from '../actions/commonActions';
import { SimManagementError } from '../models/Errors';
import { initialAppState } from '../models/state/appState';
import {
  CommandType,
  CommandTypesPayload,
  CommandTypesState,
  CommandTypesStateCacheTimeout,
  getDefaultCommandTypesState,
} from '../models/state/commandTypeState';
const log = getLogger('simManagement.reducers.commandTypesReducer');

export default function commandTypesReducer(
  state: CommandTypesState = initialAppState.commandTypes,
  action: Action<any>,
): CommandTypesState {
  switch (action.type) {
    case LOAD_COMMAND_TYPES_PENDING: {
      const newState: CommandTypesState = {
        ...getDefaultCommandTypesState(),
        isLoading: true,
      };

      return newState;
    }
    case LOAD_COMMAND_TYPES_FAILURE: {
      const { payload } = action as Action<SimManagementError>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const newState: CommandTypesState = {
        ...getDefaultCommandTypesState(),
        error: payload,
      };

      return newState;
    }

    case LOAD_COMMAND_TYPES_SUCCESS: {
      const { payload } = action as Action<CommandTypesPayload>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const changedState: CommandTypesState = {
        ...payload,
        allTypes: {},
        isLoading: false,
        expiresOn: moment().add(CommandTypesStateCacheTimeout, 'seconds').toDate(),
        lastLoadedOn: new Date(),
      };

      const types: CommandType[] = [];
      payload.groups
        .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0))
        .filter((group) => {
          group.commandTypes.filter((commandType) => {
            types.push(commandType);
          });
        });

      changedState.allTypes = Object.assign({}, ...types.map((a) => ({ [a.jsonAlias]: a })));

      const nextState = Object.assign({}, changedState);
      return nextState;
    }
    default:
      return state;
  }
}
